/* eslint-disable */
export const replacePolishCharacter = (word) => {
    return word && word.replace(/[ĄĘŚĆÓŁŃŻŹąęśćółńżź]/g, (s) => {
        return (
            s === 'Ą' ? 'A' :
            s === 'Ę' ? 'E' :
            s === 'Ś' ? 'S' :
            s === 'Ć' ? 'C' :
            s === 'Ó' ? 'O' :
            s === 'Ł' ? 'L' :
            s === 'Ń' ? 'N' :
            s === 'Ź' ? 'Z' :
            s === 'Ż' ? 'Z' :
            s === 'ą' ? 'a' :
            s === 'ę' ? 'e' :
            s === 'ś' ? 's' :
            s === 'ć' ? 'c' :
            s === 'ó' ? 'o' :
            s === 'ł' ? 'l' :
            s === 'ń' ? 'n' :
            s === 'ź' ? 'z' :
            'z'
        );
    })
};

export const replacePolishCharacterAsLowerCase = (word) => {
    return word && word.toLowerCase().replace(/[ąęśćółńżź]/g, (s) => {
        return (s === 'ą' ? 'a' : s === 'ę' ? 'e' : s === 'ś' ? 's' : s === 'ć' ? 'c' :
            s === 'ó' ? 'o' : s === 'ł' ? 'l' : s === 'ń' ? 'n' : s === 'ż' ? 'z' : 'zż') + 'ż'
    })
};
